import styled from "styled-components";

export const Container = styled.div`
    max-width: 1128px;
`;

export const TabPanel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 28px;
`;

export const Notices = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
`;

export const Spacer = styled.div`
    flex: 1 1 20px;
`;

export const ActionGroup = styled.div`
    display: flex;
    gap: 8px;
    flex: 1 1 220px;
    justify-content: flex-end;

    & > button:first-child {
        flex: 0 1 140px;
    }

    & > button:last-child {
        flex: 0 1 160px;
    }
`;
